// extracted by mini-css-extract-plugin
export default {"root":"jwzmA","subtitle":"Fz5IA"};